import { Route, Routes } from 'react-router-dom';
import VisitorRegistration from './pages/VisitorRegistration';
import InvisibleCodeView from './pages/InvisibleCodeView';
import LineCodeView from './pages/LineCodeView';

const SamsungExhibition = () => {
  return (
    <Routes>
      <Route path="register" element={<VisitorRegistration />} />
      <Route path="invisible/:confirmCode" element={<InvisibleCodeView />} />
      <Route path="visitor/:confirmCode" element={<LineCodeView />} />
    </Routes>
  );
};

export default SamsungExhibition;
